import { Component, OnInit, ViewChild } from '@angular/core';
import { TokenService } from '../shared/services/token.service';
import { SacAipIntent } from '../sac-aip.intent';
import { ViewInstructionsComponent } from './view-instructions/view-instructions.component';
import { CreateEditInstructionsComponent } from './create-edit-instructions/create-edit-instructions.component';

@Component({
    selector: 'app-mutual-fund-investing',
    templateUrl: './mutual-fund-investing.component.html',
    styleUrls: ['./mutual-fund-investing.component.scss'],
    standalone: true,
    imports: [ViewInstructionsComponent, CreateEditInstructionsComponent]
})
export class MutualFundInvestingComponent implements OnInit {
  isTokenLoaded = false;

  constructor(
    private tokenService: TokenService,
    private intent: SacAipIntent
  ) {}

  ngOnInit(): void {
    this.isTokenLoaded = false;
    this.tokenService.token = null;
    this.tokenService.getTokenCallBackAsync(this);
  }

  getTokenCallBack = function (data: string) {
    this.tokenService.token = data;
    this.token = data;
    this.isTokenLoaded = true;
  };
}
